import React, { useState, useEffect } from 'react';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';
import { useAccesos } from '../contexts/AccesosContext';

function AddProfesion({ onNewProfesion, editingProfesion }) {
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [descripcion, setDescripcion] = useState('');
    const { user } = useUser();
    const { tienePermiso } = useAccesos();
    const [modificacion, setModificacion] = useState(1);
    const [IngresadoPor, setIngresadoPor] = useState('');

    function obtenerFechaISOsinZ() {
        const fecha = new Date();
        const fechaISO = fecha.toISOString().slice(0, -1); // Elimina la 'Z'
        return fechaISO;
    }

    const fechaFormateada = obtenerFechaISOsinZ();
    useEffect(() => {
        // Si estamos editando una profesión, cargamos sus datos en el formulario
        if (editingProfesion) {
            setDescripcion(editingProfesion.descripcion);
            setModificacion(2);
            setIngresadoPor(editingProfesion.ingresadoPor);

        }else{
            setModificacion(1);
            setIngresadoPor('');

        }
    }, [editingProfesion]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const profesion = {
            id:editingProfesion ? editingProfesion.id :0,
            descripcion,
            IngresadoPor: !editingProfesion ? (user ? user.codigoUsuario : 'ADMIN               ') : IngresadoPor,
            ModificadoPor: editingProfesion ? (user ? user.codigoUsuario : 'ADMIN               ') : undefined,
          

        };
        Object.keys(profesion).forEach(key => profesion[key] === undefined && delete profesion[key]);

        // Determina si estamos editando o creando una nueva profesión
        const method = editingProfesion ? 'PUT' : 'POST';
        const endpoint = editingProfesion ? `${server}/MgProfesiones/${editingProfesion.id}` : `${server}/MgProfesiones`;

        try {
            const response = await fetch(endpoint, {
                method: method,
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(profesion),
            });

            if (response.ok) {
                setDescripcion(''); // Limpiar el formulario
                Swal.fire({
                    icon: 'success',
                    title: 'Operación exitosa',
                    showConfirmButton: false,
                    timer: 1500
                });
                onNewProfesion(); // Llamar al método para recargar las profesiones en el componente padre
            } else {
                const errorData = await response.json();
                const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                Swal.fire({
                    icon: 'error',
                    title: `Error ${response.status}`,
                    text: errorMessage,
                });            }
        } catch (error) {
              Swal.fire({
                icon: 'error',
                title: 'Error al guardar la profesión',
                text: error || 'Ocurrió un error inesperado',
            });
        }
    };

    return (
        <>
            <h2>{editingProfesion ? "Editar Profesión" : "Agregar Profesión"}</h2>
            <br />
            <form id="Perfiles" data-parsley-validate className="form-horizontal form-label-left" onSubmit={handleSubmit}>
                <div className="item form-group">
                    <label className="col-form-label col-md-3 col-sm-3 label-align" htmlFor="descripcion">
                        Descripción: <span className="required">*</span>
                    </label>
                    <div className="col-md-2 col-sm-3">
                        <input
                            type="text"
                            id="descripcion"
                            required="required"
                            className="form-control"
                            value={descripcion}
                            onChange={(e) => setDescripcion(e.target.value)}
                        />
                    </div>
                </div>
                <div className="ln_solid" />
                <div className="item form-group">
                    <div className="col-md-6 col-sm-6 offset-md-3">
                        <button type="submit" className="btn btn-success" disabled={!tienePermiso('Crear Profesión')}>Guardar</button>
                    </div>
                </div>
            </form>
        </>
    );
}

export default AddProfesion;
